












































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import firebase from 'firebase/app'

//import { VueYoutube } from "vue-youtube";

//Vue.use(VueYoutube);

interface Category {
  text: string,
  value: string,
  players: Array<Player>,
}

interface Player {
  text: string,
  value: string,
  albums: Array<Album>,
}

interface Album {
  text: string,
  value: string,
  //albums: Array<Album>,
}

interface Document3 {
  docId: string, // Category Name
  //players: Array<string>,
  category3: Category3,
}

interface Category2 {
  name: string,
  players: Array<string>,
}

interface Category3 {
  name: string,
  players: Array<Player3>,
}

interface Player3 {
  name: string,
  albums: Array<Album3>,
}

interface Album3 {
  name: string,
  //comments: Array<Comment>
}

interface Document {
  docId: string,
  content: Content
}

interface Content {
  //docId: string,
  name: string,
  videoId: string,
  kubun: string,
  category: string,
  player: string,
  album: string,
  //comments: Array<Comment>
  createdAt: string, //firebase.firestore.Timestamp, //firebase.firestore.FieldValue.serverTimestamp(),
  updatedAt: string, //firebase.firestore.Timestamp, //firebase.firestore.FieldValue.serverTimestamp(),
}

interface Comment {
  name: string, // 記事のタイトル
  items: Array<string>, // 記事の詳細
}

interface User {
  name: string,
  password: string,
}

@Component
export default class MusicComponent extends Vue {
  @Prop()
	private msg!: string;
	private isSignin: boolean = false;
	private signinStatus = "signed out"
	//private loop: boolean = false;
	private repeatFlag: boolean = false;

	private categoryIndex: number = 0;
	private categoryIndex2: number = 0;
	private categoryIndex3: number = 0;
	private playerIndex = 0
	private playerIndex2: number = 0;
	private playerIndex3: number = 0;
	private albumIndex: number = 0;
	private albumIndex2: number = 0;
	private albumIndex3: number = 0;
	private itemIndex: number = 0;

	private selectedKubun: string = "music"; // 固定
	private selectedCategory: string = "";
	private selectedPlayer: string = "";
	private selectedAlbum: string = "";

	// ここから本番データ		
	private document3s: Array<Document3> = []
	private menuCategoryIndex: number = 0
	private menuPlayerIndex: number = 0
	private menuAlbumIndex: number = 0
	
	private documents: Array<Document> = []
	private documentIndex: number = 0
	
	private docId: string = "??"
	private name: string = "name"
	//private videoId: string = "mF5Qq2YheTg"
	private videoId: string = "http://www.hiroict.com/files/talkai/トークA愛/カラオケ/ZARD/揺れる想い/01 揺れる想い.mp3"
	private kubun: string = this.selectedKubun
	private category: string = "category"
	private player: string = "player"
	private album: string = "album"
	//private comments: string = "comments"
	private createdAt: string = "createdAt"
	private updatedAt: string = "updatedAt"
	private addResult: string = "result_add"
	private updateResult: string = "result_update"
	
	private user: User = {name:"", password:""}
	private query_document: Document = {docId:"", content: {name:"", videoId:""/*, comments:[{name: "name", items: [""]}]*/, kubun:"youtube", category:"", player:"", album:"", createdAt: "", updatedAt: ""}}
	private add_document: Document = {docId:"", content: {name:"", videoId:""/*, comments:[{name: "name", items: [""]}]*/, kubun:"youtube", category:"", player:"", album:"", createdAt: "", updatedAt: ""}}

	private comments: Array<Comment> = []
	private talka: Array<string> = []

  // ライフサイクルフック
  public created(){
	this.queryMenuProc()
	//this.queryContentsProc('contents')
	const user = this.$auth.currentUser;
	if (user) {
		// User is signed in.
		const email = user.email
		window.console.log("created() 1.email: " + email)
		if (email == "toru.watanabe11@gmail.com") {
			this.isSignin = true
			this.signinStatus = "signed in"
		} else {
			this.isSignin = false
			this.signinStatus = "signed out"
		}
	} else {
		// No user is signed in.
		this.isSignin = false
		this.signinStatus = "signed out"
	}
  }

  public onEnded() {
      window.console.log("onEnded() 1.documentIndex_1: " + this.documentIndex);
      //window.interactiveCanvas.sendTextQuery('もう一度');
      //this.nextAudio()
      if (this.repeatFlag) {
      	//this.loop = true
      	//this.selectContent(this.documentIndex)
      	//const audio =this.$refs.player
      	//audio.play()
      	//var audio1 = document.getElementById("audio1");
      	//audio1!.play()
      	//var playbackTime = audio1.currentTime;
      } else { 
      	this.nextContent()
      }
  }

	private playVideo(): void {
		//const player =this.$refs.youtube.player.playVideo()
		//this.player.playVideo()
	}
	
	private ready() {
		window.console.log("ready() 1.")
		/*
		const youtubePlayer = this.$refs.youtube.player
		youtubePlayer.resize = true
		window.console.log("ready() 2.width: " + youtubePlayer.width)
		youtubePlayer.fitParent = true
		youtubePlayer.width = 1280
		youtubePlayer.height= 720
		window.console.log("ready() 3.width: " + youtubePlayer.width)
		youtubePlayer.resize = true
		youtubePlayer.playVideo()
		*/
	} 

	private click_add(): void {
		//window.console.log("click_add() 1.name: " + this.user.name + ", password: " + this.user.password)
		//this.queryContentsProc()
		window.console.log("click() 1.name: " + this.add_document.content.name)
		window.console.log("click() 2.videoId: " + this.add_document.content.videoId)
		window.console.log("click() 3.kubun: " + this.add_document.content.kubun)
		window.console.log("click() 4.category: " + this.add_document.content.category)
		window.console.log("click() 5.player: " + this.add_document.content.player)
		window.console.log("click() 6.album: " + this.add_document.content.album)
		var message = ""
		if (this.add_document.content.name == "") {
			alert("nameが空白です")
			return
		}
		if (this.add_document.content.videoId == "") {
			alert("videoIdが空白です")
			return
		}
		if (this.add_document.content.kubun == "") {
			alert("kubunが空白です")
			return
		}
		if (this.add_document.content.category == "") {
			alert("categoryが空白です")
			return
		}
		if (this.add_document.content.player == "") {
			alert("playerが空白です")
			return
		}
		if (this.add_document.content.album == "") {
			alert("albumが空白です")
			return
		}
		var message = "name: " + this.add_document.content.name
		message += "\nvideoId: " + this.add_document.content.videoId
		message += "\nkubun: " + this.add_document.content.kubun
		message += "\ncategory: " + this.add_document.content.category
		message += "\nplayer: " + this.add_document.content.player
		message += "\nalbum: " + this.add_document.content.album
		message += "\n\nの内容で登録しますか？"
		const ans = confirm(message)
		if (ans) {
			this.addDocument()
			//alert("登録機能は未サポートです")
		}
	}
	
	private click_update(): void {
		//window.console.log("click_edit() 1.name: " + this.user.name + ", password: " + this.user.password)
		//this.queryContentsProc()
		window.console.log("click_update() 1.name: " + this.query_document.content.name)
		window.console.log("click_update() 2.videoId: " + this.query_document.content.videoId)
		window.console.log("click_update() 3.kubun: " + this.query_document.content.kubun)
		window.console.log("click_update() 4.category: " + this.query_document.content.category)
		window.console.log("click_update() 5.player: " + this.query_document.content.player)
		window.console.log("click_update() 6.album: " + this.query_document.content.album)
		var message = ""
		if (this.query_document.content.name == "") {
			alert("nameが空白です")
			return
		}
		if (this.query_document.content.videoId == "") {
			alert("videoIdが空白です")
			return
		}
		if (this.query_document.content.kubun == "") {
			alert("kubunが空白です")
			return
		}
		if (this.query_document.content.category == "") {
			alert("categoryが空白です")
			return
		}
		if (this.query_document.content.player == "") {
			alert("playerが空白です")
			return
		}
		if (this.query_document.content.album == "") {
			alert("albumが空白です")
			return
		}
		var message = "name: " + this.query_document.content.name
		//this.query_document.content.createdAt = this.getStringFromDate(new Date())

		message += "\nvideoId: " + this.query_document.content.videoId
		message += "\nkubun: " + this.query_document.content.kubun
		message += "\ncategory: " + this.query_document.content.category
		message += "\nplayer: " + this.query_document.content.player
		message += "\nalbum: " + this.query_document.content.album
		message += "\ncreatedAt: " + this.query_document.content.createdAt
		message += "\nupdatedAt: " + this.query_document.content.updatedAt
		message += "\n\nの内容で編集しますか？"
		const ans = confirm(message)
		if (ans) {
			this.updateDocument()
			//alert("編集機能は未サポートです")
		}
	}
	
	// 「firestore」に新しいドキュメントを登録する
	public addDocument() {
		window.console.log("addDocument() 1.")
		const admin = require("firebase-admin")
		//this.add_document.content.createdAt = admin.firestore.FieldValue.serverTimestamp()
		this.add_document.content.createdAt = this.getStringFromDate(new Date())
		//this.add_document.content.updatedAt = admin.firestore.FieldValue.serverTimestamp()
		this.add_document.content.updatedAt = this.getStringFromDate(new Date())
		const contentsRef = this.$firestore.collection('contents')
		contentsRef.add(this.add_document.content)
		.then((docRef: any) => {
			const message = "Document written with ID: " + docRef.id
			this.addResult = message
			window.console.log("addDocument() 2." + message)
			this.add_document.content.name = ""
			this.add_document.content.videoId = ""
			this.add_document.content.album = ""
		})
		.catch((error: any) => {
			window.console.log("addDocument() 3.Error adding document: " + error)
		})
	}

	// 「firestore」に既存のドキュメントを更新する
	public updateDocument() {
		window.console.log("updateDocument() 1.createdAt: " + this.query_document.content.createdAt)
		//const admin = require("firebase-admin")
		//const serviceAccount = require("../firebase/helloapp-87353-firebase-adminsdk-bib6q-00edf42ca1.json");
		//admin.initializeApp({credential: admin.credential.cert(serviceAccount)})
		if (this.query_document.content.createdAt == undefined || this.query_document.content.createdAt == "") {
			window.console.log("updateDocument() 2.createdAt: " + this.query_document.content.createdAt)
			//this.query_document.content.createdAt = admin.firestore.FieldValue.serverTimestamp()
			//this.query_document.content.createdAt = this.$firestore.FieldValue.serverTimestamp()
			this.query_document.content.createdAt = this.getStringFromDate(new Date())
			window.console.log("updateDocument() 3.createdAt: " + this.query_document.content.createdAt)
		}
		//this.query_document.content.createdAt = this.getStringFromDate(new Date())
		//this.query_document.content.updatedAt = admin.firestore.FieldValue.serverTimestamp()
		//this.query_document.content.updatedAt = this.$firestore.FieldValue.serverTimestamp()
		//this.query_document.content.createdAt = this.getStringFromDate(new Date())
		this.query_document.content.updatedAt = this.getStringFromDate(new Date())
		const contentsRef = this.$firestore.collection('contents')
		contentsRef.doc(this.query_document.docId).update(this.query_document.content)
		.then(() => {
			const message = "Document updated with ID: " + this.query_document.docId
			this.updateResult = message
			window.console.log("updateDocument() 4." + message)
			//this.add_document.content.name = ""
			//this.add_document.content.videoId = ""
			//this.add_document.content.album = ""
		})
		.catch((error: any) => {
			window.console.log("updateDocument() 5.Error adding document: " + error)
		})
		//*/
	}

	//日付から文字列に変換する関数
	private getStringFromDate(date: Date): string {
		//var today: Date = Date()
		var year_str = date.getFullYear();
		//月だけ+1すること
		var month_str = 1 + date.getMonth();
		var day_str = date.getDate();
		var hour_str = date.getHours();
		var minute_str = date.getMinutes();
		var second_str = date.getSeconds();


		var format_str = "YYYY-MM-DD hh:mm:ss";
		format_str = format_str.replace(/YYYY/g, year_str.toString());
		format_str = format_str.replace(/MM/g, month_str.toString());
		format_str = format_str.replace(/DD/g, day_str.toString());
		format_str = format_str.replace(/hh/g, hour_str.toString());
		format_str = format_str.replace(/mm/g, minute_str.toString());
		format_str = format_str.replace(/ss/g, second_str.toString());

		return format_str;
	}
	
	// 「firestore」に「music」コレクションのドキュメントを検索する
	private queryMenuProc() {
		window.console.log("queryMenuProc() 1.selectedKubun: " + this.selectedKubun)
		//window.console.log("queryMenuProc() 2.selectedCategory: " + this.selectedCategory)
		//window.console.log("queryMenuProc() 3.selectedPlayer: " + this.selectedPlayer)
		//window.console.log("queryMenuProc() 4.selectedAlbum: " + this.selectedAlbum)
		// document3sを初期化する
		this.document3s.splice(0)
		const collectionRef = this.$firestore.collection(this.selectedKubun) // ①
		window.console.log("queryMenuProc() 2.collectionRef: " + collectionRef)
		collectionRef
			// 「"youtube」コレクションを読む
			.get().then((snapShot: any) => { // ②
				snapShot.forEach((doc: any) => { // ③
					// ドキュメント単位に処理
					window.console.log("queryMenuProc() 3.doc.id: " + doc.id)
					var data = doc.data() // ④
					window.console.log("queryMenuProc() 4.players: " + data.players)
					// player3sを作成する
					var player3s: Array<Player3> = []
					// 「players」フィードをスキャンする
					data.players.forEach((player: string) =>{
						window.console.log("queryMenuProc() 5.player: " + player)
						var albums = data[player]
						window.console.log("queryMenuProc() 6.albums: " + albums)
						// album3sを作成する
						var album3s: Array<Album3> = []
						albums.forEach((album: string) => {
							// commentsを作成する
							window.console.log("queryMenuProc() 7.album: " + album)
							//const comments: Array<Comment> = [{name: "記事1", items: ["説明1", "説明2"]}] 
							const album3:Album3 = {name: album/*, comments: comments*/}
							album3s.push(album3)
						})
						// player3を作成する
						var player3:Player3 = {name: player, albums: album3s}
						player3s.push(player3)
					})
					// document3を作成する
					var document3: Document3 = {docId:doc.id, category3: {name:doc.id, players: player3s}}
					this.document3s.push(document3) // メニューに追加する
				}) // end of forEach
				
				window.console.log("queryContentsProc() 12.最初のコンテンツを表示する")
				// ソート処理を行う
				const sortedArray: Document3[] = this.document3s.sort((n1,n2) => {
				    if (n1.docId > n2.docId) {
				        return 1;
				    }
				    if (n1.docId < n2.docId) {
				        return -1;
				    }
				    return 0;
				})
				window.console.log("queryContentsProc() 13.最初のカテゴリ等を決定する")
				if (this.document3s.length > 0) {
					this.selectedCategory = this.document3s[0].docId
					if (this.document3s[0].category3.players.length > 0) {
						this.selectedPlayer = this.document3s[0].category3.players[0].name
						if (this.document3s[0].category3.players[0].albums.length > 0) {
							this.selectedAlbum = this.document3s[0].category3.players[0].albums[0].name
						}
					}
				}
				this.query_document.content.category = this.selectedCategory
				this.query_document.content.player = this.selectedPlayer
				this.query_document.content.album = this.selectedAlbum
				this.add_document.content.category = this.selectedCategory
				this.add_document.content.player = this.selectedPlayer
				this.add_document.content.album = this.selectedAlbum
				
			}) // end of then
			.catch((error: any) => {
				window.console.log("queryMenuProc() 19.Error querying document: " + error)
				//var document3: Document3 = {docId:"??", players: ["コンテンツは見つかりません"], category3: {name:"??", players: []}}
				//this.document3s.push(document2)
			})
			//this.firstContent()
			//})
		//})
		//window.console.log("queryMenuProc() 21." + this.$watanabe)
	} // end of queryMenuProc

	// 「firestore」に「youtube」コレクションのドキュメントを検索する
	private queryMenuProc2() {
		//window.console.log("queryMenuProc2() 1.selectedDocId: " + this.document3s[this.menuCategoryIndex].docId)	
		window.console.log("queryMenuProc2() 1.selectedKubun: " + this.selectedKubun)
		window.console.log("queryMenuProc2() 2.selectedCategory: " + this.selectedCategory)
		window.console.log("queryMenuProc2() 3.selectedPlayer: " + this.selectedPlayer)
		//window.console.log("queryMenuProc2() 4.selectedAlbum: " + this.selectedAlbum)
		var docId = this.selectedCategory
		var player = this.selectedPlayer
		this.comments.splice(0)
		this.talka.splice(0)
		const collectionRef = this.$firestore.collection(this.selectedKubun) // ①
		const collection2Ref = collectionRef.doc(docId).collection(player)
		collection2Ref.get().then((snapShot2: any) => {
			snapShot2.forEach ((doc2: any) => { // ③
				// ドキュメント単位に処理
				window.console.log("queryMenuProc2() 7.category: " + docId + ", player: " + player + ", doc2.id: " + doc2.id)
				var data2 = doc2.data()
				if (data2.talka != undefined) {
					data2.talka.forEach((item: string) => {
						this.talka.push(item)
					})
				}
				var albums = data2.albums
				window.console.log("queryMenuProc2() 8.albums: " + albums)
				// 「albums」フィールドのリストを調べる
				albums.forEach((album: string) => {
					window.console.log("queryMenuProc2() 9.album: " + album)
					//var comment: Comment = {name: "", items:[]}
					if (data2[album] == undefined) {
						window.console.log("queryMenuProc() 10.data2[album]は存在しない: ")
					} else {
						// data2[album]は、アルバムの名前のフイールドを示す
						window.console.log("queryMenuProc2() 11.data2[album]は存在する: " + data2[album].items)
						if (album == this.selectedAlbum) {
							var index = 0
							data2[album].items.forEach((item: any) => {
								index++
								var comment: Comment = {name: index + ". " + item, items:[]}
								window.console.log("queryMenuProc2() 12.data2[album]は存在する item: " + item)
								//comment.name = item
								if (data2[album][item] == undefined) {
									window.console.log("queryMenuProc2() 13.data2[album]は存在しない: ")
								} else {
									window.console.log("queryMenuProc2() 14.data2[album[item]]は存在する data2[album][item]: " + data2[album][item])
									comment.items = data2[album][item]							
								}						
								this.comments.push(comment)
							})
							if (docId == "ダンス音楽") {
								index++
								var comment_talka: Comment = {name: index + ". " + "「トークA」関係", items: this.talka}
								this.comments.push(comment_talka)
							}
						}
					}
					// commentsを作成する
					//const comments: Array<Comment> = [{name: "記事1", items: ["説明1", "説明2"]}] 
					//const album3:Album3 = {name: album, comments: comments}
					//album3s.push(album3)
					//this.comments.push(comment)
				}) // end of albums.forEach
			})  // end of snapShot2.forEach
			/*
			if (this.comments.size > 0) {
				this.slectedAlbumExplanation = "記事の件数は" + this.comments.size + "です。"
			} else {
				this.slectedAlbumExplanation = "記事の件数は" + this.comments.size + "です。"
			}
			*/
			//this.queryContentsProc()
		}) // end of then
	}
	
	// 「firestore」に「contents」コレクションのドキュメントを検索する
	private queryContentsProc(/*collectionName: string*/) {
		//window.console.log("queryContentsProc() 1.collectionName: " + collectionName)
		window.console.log("queryContentsProc() 2.selectedKubun: " + this.selectedKubun)
		window.console.log("queryContentsProc() 3.selectedCategory: " + this.selectedCategory)
		window.console.log("queryContentsProc() 4.selectedPlayer: " + this.selectedPlayer)
		window.console.log("queryContentsProc() 5.selectedAlbum: " + this.selectedAlbum)
		this.comments.splice(0)
		this.talka.splice(0)
		this.documents.splice(0)
		const contentsRef = this.$firestore.collection('contents') // ①
		contentsRef
			.where('kubun', '==', this.selectedKubun)
			.where('category', '==', this.selectedCategory)
			.where('player', '==', this.selectedPlayer)
			.where('album', '==', this.selectedAlbum)
			.get().then((snapShot: any) => { // ②
				snapShot.forEach ((doc: any) => { // ③
				//snapShot.docs.map ((doc: any) => { // ③
					var data = doc.data() // ④
					this.docId = doc.id
					window.console.log("queryContentsProc() 6.doc.id: " + doc.id)
					window.console.log("queryContentsProc() 7.name: " + data.name)
					window.console.log("queryContentsProc() 8.videoId: " + data.videoId)
					window.console.log("queryContentsProc() 9.kubun: " + data.kubun)
					window.console.log("queryContentsProc() 10.category: " + data.category) 
					window.console.log("queryContentsProc() 11.player: " + data.player)
					window.console.log("queryContentsProc() 12.album: " + data.album)
					/*
					window.console.log("queryContentsProc() 13.comments: " + data.comments)
					data.comments.forEach((comment: any) => {
						//window.console.log("queryContentsProc() 14.comment: " + comment['記事1'])
						window.console.log("queryContentsProc() 15.comment: " + comment)
						window.console.log("queryContentsProc() 16.doc.id: " + doc.id)
						
						const commentRef = contentsRef.doc(doc.id).collection(comment)
						commentRef.get().then((snapShot2: any) => {
							snapShot2.forEach((doc2: any) => {
								var data2 = doc2.data()
								window.console.log("queryContentsProc() 17.doc2.items: " + data2.items)
								this.comments = comment + "\n" +data2.items
							})
						})
						
					})
					*/
					var document: Document = {docId:doc.id, content: {name:data.name, videoId:data.videoId/*, comments:[{name: "name", items: [""]}]*/, kubun:data.kubun, category:data.category, player:data.player, album:data.album, createdAt:data.createdAt, updatedAt:data.updatedAt}}
					this.documents.push(document)
					window.console.log("queryContentsProc() 15.document.docId: " + document.docId)
				}) // end of forEach
				window.console.log("queryContentsProc() 16.最初のコンテンツを表示する")
				// ソート処理を行う
				const sortedArray: Document[] = this.documents.sort((n1,n2) => {
				    if (n1.content.name > n2.content.name) {
				        return 1;
				    }
				    if (n1.content.name < n2.content.name) {
				        return -1;
				    }
				    return 0;
				});
				this.firstContent()
			}) // end of then
			.catch((error: any) => {
				window.console.log("queryContentsProc() 17.Error querying document: " + error)
				//var document: Document = {docId:"??", content: {name:"コンテンツは見つかりません。検索をしてください。", videoId:"mF5Qq2YheTg", kubun:"??", category:"??", player:"??", album:"??", createdAt:"??", updatedAt:"??"}}
				//this.documents.push(document)
				this.docId = "??"
				this.name = "コンテンツは見つかりません。検索をしてください。"
				this.videoId = "mF5Qq2YheTg"
				this.kubun = "??"
				this.category = "??"
				this.player = "??"
				this.album = "??"
				this.createdAt = "??"
				this.updatedAt = "??"

				this.firstContent()
				
			})
			//this.firstContent()
			//})
		//})
		//window.console.log("queryContentsProc() 18." + this.$watanabe)
	} // end of queryContentsProc

	private repeatProc() {
		window.console.log("repeatProc() 1.repeatFlag: " + this.repeatFlag)
		this.repeatFlag = !this.repeatFlag
	}
	
	private selectContent(index: number) {
		window.console.log("selectContent() 1.index: " + index)
		this.documentIndex = index
		// ドキュメントを得る
	    const document = this.documents[this.documentIndex]
		window.console.log("selectContent() 2.document.content.name: " + document.content.name)
		this.docId = document.docId
		this.name = document.content.name
		this.videoId = ""
		this.videoId = document.content.videoId
		this.kubun = document.content.kubun
		this.category = document.content.category
		this.player = document.content.player
		this.album = document.content.album
		this.createdAt = document.content.createdAt
		this.updatedAt = document.content.updatedAt
		
		this.query_document.docId = document.docId
		this.query_document.content.name = document.content.name
		this.query_document.content.videoId = document.content.videoId
		this.query_document.content.kubun = document.content.kubun
		this.query_document.content.category = document.content.category
		this.query_document.content.player = document.content.player
		this.query_document.content.album = document.content.album
		this.query_document.content.createdAt = document.content.createdAt
		this.query_document.content.updatedAt = document.content.updatedAt

		this.changeSelectedCategory3()
	}
	
	private firstContent() {
		window.console.log("firstContent() 1.")
		if (this.documents.length > 0) {
			this.documentIndex = 0
		    var document = this.documents[this.documentIndex]
			window.console.log("firstContent() 2.document.content.name: " + document.content.name)
			this.docId = document.docId
			this.name = document.content.name
			this.videoId = document.content.videoId
			this.kubun = document.content.kubun
			this.category = document.content.category
			this.player = document.content.player
			this.album = document.content.album
			this.createdAt = document.content.createdAt
			this.updatedAt = document.content.updatedAt
			
			this.query_document.docId = document.docId
			this.query_document.content.name = document.content.name
			this.query_document.content.videoId = document.content.videoId
			this.query_document.content.kubun = document.content.kubun
			this.query_document.content.category = document.content.category
			this.query_document.content.player = document.content.player
			this.query_document.content.album = document.content.album
			this.query_document.content.createdAt = document.content.createdAt
			this.query_document.content.updatedAt = document.content.updatedAt

			this.changeSelectedCategory3()
		}
	}

	private nextContent() {
		window.console.log("nextContent() 1.this.documents.length: " + this.documents.length)
		if (this.documents.length > 0) {
			this.documentIndex++
			if (this.documentIndex >= this.documents.length) {
				this.documentIndex = 0
			}
		    var document = this.documents[this.documentIndex]
			window.console.log("firstContent() 2.document.content.name: " + document.content.name)
			this.docId = document.docId
			this.name = document.content.name
			this.videoId = document.content.videoId
			this.kubun = document.content.kubun
			this.category = document.content.category
			this.player = document.content.player
			this.album = document.content.album
			this.createdAt = document.content.createdAt
			this.updatedAt = document.content.updatedAt
			
			this.query_document.docId = document.docId
			this.query_document.content.name = document.content.name
			this.query_document.content.videoId = document.content.videoId
			this.query_document.content.kubun = document.content.kubun
			this.query_document.content.category = document.content.category
			this.query_document.content.player = document.content.player
			this.query_document.content.album = document.content.album
			this.query_document.content.createdAt = document.content.createdAt
			this.query_document.content.updatedAt = document.content.updatedAt
			
			this.changeSelectedCategory3()
		}
	}

	private previousContent() {
		window.console.log("previousContent() 1.")
		if (this.documents.length > 0) {
			this.documentIndex--
			if (this.documentIndex < 0) {
				this.documentIndex = this.documents.length - 1
			}
		    var document = this.documents[this.documentIndex]
			window.console.log("previousContent() 2.document.content.name: " + document.content.name)
			this.docId = document.docId
			this.name = document.content.name
			this.videoId = document.content.videoId
			this.kubun = document.content.kubun
			this.category = document.content.category
			this.player = document.content.player
			this.album = document.content.album
			this.createdAt = document.content.createdAt
			this.updatedAt = document.content.updatedAt
			
			this.query_document.docId = document.docId
			this.query_document.content.name = document.content.name
			this.query_document.content.videoId = document.content.videoId
			this.query_document.content.kubun = document.content.kubun
			this.query_document.content.category = document.content.category
			this.query_document.content.player = document.content.player
			this.query_document.content.album = document.content.album
			this.query_document.content.createdAt = document.content.createdAt
			this.query_document.content.updatedAt = document.content.updatedAt

			this.changeSelectedCategory3()
		}
	}

	// ドキュメントの検索
	private changeSelectedCategory(): void {
		window.console.log("changeSelectedCategory() 1.this.selectedCategory: " + this.selectedCategory)
		this.document3s.forEach((doc, index) => {
			window.console.log("changeSelectedCategory() 2.index: " + index)
			window.console.log("changeSelectedCategory() 3.doc.docId: " + doc.docId)
			if (this.selectedCategory == doc.docId) {
				window.console.log("changeSelectedCategory() 4.doc.docId: " + doc.docId + ", index: " + index)
				this.menuCategoryIndex = index
				if (this.document3s[this.menuCategoryIndex].category3.players.length > 0) {
					this.selectedPlayer = this.document3s[this.menuCategoryIndex].category3.players[0].name
					window.console.log("changeSelectedCategory() 5.this.selectedPlayer: " + this.selectedPlayer)
				}
				//break
			}
		})
		this.changeSelectedPlayer()
	}

	
	// ドキュメントの登録
	private changeSelectedCategory2(): void {
		window.console.log("changeSelectedCategory2() 1.this.add_cdocument.ontent.category: " + this.add_document.content.category)
		this.document3s.forEach((doc, index) => {
			window.console.log("changeSelectedCategory2() 2.index: " + index)
			window.console.log("changeSelectedCategory2() 3.doc.docId: " + doc.docId)
			if (this.add_document.content.category == doc.docId) {
				window.console.log("changeSelectedCategory2() 4.doc.docId: " + doc.docId + ", index: " + index)
				this.categoryIndex2 = index
				if (this.document3s[this.menuCategoryIndex].category3.players.length > 0) {
					this.add_document.content.player = this.document3s[this.menuCategoryIndex].category3.players[0].name
				}
			}
		})
		this.changeSelectedPlayer2()
	}

	// ドキュメントの更新
	private changeSelectedCategory3(): void {
		window.console.log("changeSelectedCategory3() 1.this.query_document.content.category: " + this.query_document.content.category)
		this.document3s.forEach((doc, index) => {
			window.console.log("changeSelectedCategory3() 2.index: " + index)
			window.console.log("changeSelectedCategory3() 3.doc.docId: " + doc.docId)
			if (this.query_document.content.category == doc.docId) {
				window.console.log("changeSelectedCategory3() 4.doc.docId: " + doc.docId + ", index: " + index)
				this.categoryIndex3 = index
				if (this.document3s[this.menuCategoryIndex].category3.players.length > 0) {
					this.query_document.content.player = this.document3s[this.menuCategoryIndex].category3.players[0].name
				}
			}
		})
		this.changeSelectedPlayer3()
		/*
		//for (const [index, category] of this.categories) {
		this.categories.forEach((category, index) => {
			window.console.log("changeSelectedCategory3() 2.index: " + index)
			window.console.log("changeSelectedCategory3() 3.category.value: " + category.value)
			if (this.query_document.content.category == category.value) {
				window.console.log("changeSelectedCategory3() 4.category.value: " + category.value + ", index: " + index)
				this.categoryIndex3 = index
				if (this.categories[this.categoryIndex3].players.length > 0) {
					this.categories[this.categoryIndex3].players.forEach((player, index2) => {
						if (this.query_document.content.player == player.value) {
							this.playerIndex3 = index2
							this.query_document.content.player = this.categories[this.categoryIndex3].players[index2].text
						} // end of if
					}) // end of forEach
				}
				//break
			} // end of if
		}) // end of forEach
		this.changeSelectedPlayer3()
		*/
	}

	// ドキュメントの検索
	private changeSelectedPlayer(): void {
		window.console.log("changeSelectedPlayer() 1.this.selectedPlayer: " + this.selectedPlayer)
		this.document3s[this.menuCategoryIndex].category3.players.forEach((player, index) => {
			window.console.log("changeSelectedPlayer() 2.index: " + index)
			window.console.log("changeSelectedPlayer() 3.player.name: " + player.name)
			if (this.selectedPlayer == player.name) {
				window.console.log("changeSelectedPlayer() 4.player.name: " + player.name + ", index: " + index)
				this.menuPlayerIndex = index
				///*
				if (this.document3s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums.length > 0) {
					this.selectedAlbum = this.document3s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums[0].name
				}
				//*/
				//break
			}			
		})
		this.changeSelectedAlbum()
	}

	// ドキュメントの登録
	private changeSelectedPlayer2(): void {
		window.console.log("changeSelectedPlayer2() 1.this.add_document.content.player: " + this.add_document.content.player)
		this.document3s[this.menuCategoryIndex].category3.players.forEach((player, index) => {
			window.console.log("changeSelectedPlayer2() 2.index: " + index)
			window.console.log("changeSelectedPlayer2() 3.player.name: " + player.name)
			if (this.add_document.content.player == player.name) {
				window.console.log("changeSelectedPlayer2() 4.player.name: " + player.name + ", index: " + index)
				this.playerIndex2 = index
				if (this.document3s[this.categoryIndex2].category3.players[this.playerIndex2].albums.length > 0) {
					this.add_document.content.album = this.document3s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums[0].name 
				}
			}
		})
		this.changeSelectedAlbum2()
	}

	// ドキュメントの更新
	private changeSelectedPlayer3(): void {
		window.console.log("changeSelectedPlayer3() 1.this.query_document.content.player: " + this.query_document.content.player)
		//this.queryContentsProc()
	}

	// 使用していない
	private changeSelectedAlbum(): void {
		window.console.log("changeSelectedAlbum() 1.this.selectedAlbum: " + this.selectedAlbum)
		//this.queryContentsProc()
	}

	// 使用している	
	private changeSelectedAlbum2(): void {
		window.console.log("changeSelectedAlbum2() 1.this.add_document.content.album: " + this.add_document.content.album)
		//this.queryContentsProc()
	}

	// 「firestore」にプログラム的に新しいドキュメントを登録する
	public registerProc() {
		alert("生成機能は未サポートです")
		/*
		//const registerAlbum = this.dance_album_1
		//const registerAlbum = this.dance_album_2
		//const registerAlbum = this.karaoke_album_1
		//const registerAlbum = this.karaoke_album_2
		//const registerAlbum = this.karaoke_album_3
		//const registerAlbum = this.karaoke_album_4
		const registerAlbum = this.karaoke_album_5
		const url = registerAlbum.url
		window.console.log("registerProc() 1.url: " + url)
		const kubun = "music"
		window.console.log("registerProc() 2.kubun: " + kubun)
		//const category = "ダンス音楽"
		//const category = "カラオケ音楽（女性）"
		const category = "カラオケ音楽（男性）"
		window.console.log("registerProc() 3.category: " + category)
		const player = registerAlbum.player
		window.console.log("registerProc() 4.player: " + player)
		const album = registerAlbum.title
		window.console.log("registerProc() 5.album: " + album)
		registerAlbum.items.forEach((item, index) => {
			// name: string,
			this.add_document.content.name = item.title
			window.console.log("registerProc() 6.item.title: " + item.title)
			// videoId: string,
			const videoId = url + item.title + "." + item.type
			this.add_document.content.videoId = videoId
			window.console.log("registerProc() 7.videoId: " + videoId)
			// kubun: string,
			this.add_document.content.kubun = kubun
			// category: string,
			this.add_document.content.category = category
			// player: string,
			this.add_document.content.player = player
			// album: string,
			this.add_document.content.album = album
			// createdAt: string,
			this.add_document.content.createdAt = this.getStringFromDate(new Date())
			// updatedAt: string,
			this.add_document.content.updatedAt = this.getStringFromDate(new Date())
			let message = "name: " + this.add_document.content.name
			message += "\nvideoId: " + this.add_document.content.videoId
			message += "\nkubun: " + this.add_document.content.kubun
			message += "\ncategory: " + this.add_document.content.category
			message += "\nplayer: " + this.add_document.content.player
			message += "\nalbum: " + this.add_document.content.album
			message += "\ncreatedAt: " + this.add_document.content.createdAt
			message += "\nupdatedAt: " + this.add_document.content.updatedAt
			message += "\n\nの内容で登録しますか？"
			const ans = confirm(message)
			if (ans) {
				const contentsRef = this.$firestore.collection('contents')
				contentsRef.add(this.add_document.content)
				.then((docRef: any) => {
					const message = "Document written with ID: " + docRef.id
					this.addResult = message
					window.console.log("registerProc() 8." + message)
					this.add_document.content.name = ""
					this.add_document.content.videoId = ""
					this.add_document.content.album = ""
				})
				.catch((error: any) => {
					window.console.log("registerProc() 9.Error adding document: " + error)
				})
			}
		})
		*/
	}

	/*
	//@Emit('updateVideoSelected')
	private updateVideoSelected(selected: string): void{
		window.console.log("updateVideoSelected() 1.selected: " + selected);
		for (var index in this.albums[this.selectedAlbumIndex].items) {
			window.console.log("updateVideoSelected() 2.item_name: " + this.albums[this.selectedAlbumIndex].items[index].name);
			if (this.selectedAlbum == this.albums[this.selectedAlbumIndex].items[index].name) {
				window.console.log("updateVideoSelected() 3.item_index: " + index);
				this.selectedVideoIndex = index
			}
		}
	
	}
	*/
  

  /*
  album_1: Album = {
    title: "ワルツ",
    items: [{id: 'ibuWJv6ncDg', title: '社交ダンス ワルツ 2017日本インター規定フィガー 競技ダンス',
             comment: {title: '競技ダンス', items: ['コメント']}},
            {id: '-DBmZqeww0E', title: 'ワルツのステップ ナチュラルスピンターン 群馬県の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['スピンターンはワルツの華なので一生懸命練習する。']}},
            {id: 'zjDmH4BpIt0', title: 'ワルツのステップ リバースターン 群馬県の社交ダンス教室',
             comment: {title: 'Reverse Turn', items: ['リバースターンは下半身（足）が優先する。']}},
            {id: 'QpJbcSAWLoE', title: 'ワルツのステップ ウィスク 群馬県の社交ダンス教室',
             comment: {title: 'Wisk', items: ['ウィスクでは、PP（Promenade Position）の体勢になる。']}},
            {id: 'RgJx0dxb5XE', title: 'ワルツのステップ シャッセ from PP 群馬県の社交ダンス教室',
             comment: {title: 'Chasse from PP', items: ['シャッセ（12&3）の2&は爪先で移動する。']}},
            {id: 'SnAnapDLVPA', title: 'ワルツのステップ アウトサイドチェンジ 群馬県の社交ダンス教室',
             comment: {title: 'Outside Change', items: ['アウトサイドチェンジは、進行方向を変える時に有効である。']}},
            {id: 'YPRJN6VlZ_8', title: 'ワルツのステップ バックロック 群馬県の社交ダンス教室',
             comment: {title: 'Back Lock', items: ['バックロックは、男性が足を交差させながら後退する。']}},
            {id: 'b9CEZP8AcSU', title: 'ラインフィギュア - ウォルツのオーバーウェイ|基本ルーチン',
             comment: {title: 'Overway', items: ['オーバーウェイは、男性は左足に体重をかけ左脇の筋肉を伸ばす。']}},
            {id: '_21rn8_U6i4', title: 'ワルツのステップ コントラチェック 群馬県の社交ダンス教室',
             comment: {title: 'Contra Check', items: ['男性は、左足と右肩を前に出す。']}},
            {id: 'yIs96598t_0', title: 'ワルツのステップ ウィーブ from PP 群馬県の社交ダンス教室',
             comment: {title: 'Weave from PP', items: ['リバースターンでナチュラルに回転する。']}},
            {id: 'x8Z47e_O-tU', title: 'ワルツのステップ バックウィスク 群馬県の社交ダンス教室',
             comment: {title: 'Back Wisk', items: ['右脇の筋肉を伸ばす。']}},
            {id: '7vl5-iA4DsQ', title: 'ワルツのステップ ターニングロック to ライト 群馬県の社交ダンス教室',
             comment: {title: 'Turnin Lock to Right', items: ['ターニングロック to ライトは、右回転に移動する。']}},
           ],
    comment:{
      title:'トークＡにおけるワルツ（初級）のアルガメーション',
      items: ['セットアップから予備歩（123 123 123 123）',
              'Natural Spin Turn（123 456）',
              'Reverse Turn(456)',
              'Reverse Turn(123 456)',
              'Whisk(123)',
              'Chasse from Promenade Position(12&3)',
              'Outside Change（123)',
              'Natural Spin Turn（123 456）',
              'Back Lock(1&23)',
              'Oversway(123 123)',
              'Contra Check(123)',
              'Chasse from Promenade Position(12&3)',
              'Natural Turn（123)',
              'Open Impetus(123)',
              'Weave from Promenade Position(123 123)',
              'Chasse from Promenade Position(12&3)',
              'Outside Change(123)',
              'Natural Turn（123)',
              'Back Wisk(123)',
              'Wing(123)',
              'Progressive Chasse to Right(12&3)',
              'Outside Change(123)',
              'Natural Turn(123)',
              'Open Impetus(123)',
              'Chasse from Promenade Position(12&3)',
              'Quick Open Reverse(12&3)',
              'Reverse Turn（456)',
              'Throwaway Oversway(123 123 123)',
              'Chasse from Promenade Position(12&3)',
              'Natural Turn（123)',
           ],
    },
  };
  
  album_2 : Album = {
    title: 'タンゴ',
    items: [{id: '9Fp4JGIlWmI', title: 'タンゴのステップ プログレッシブリンク 群馬県の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'mz9hi1UgbPk', title: 'タンゴのステップ クローズドプロムナード 群馬県の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'IyDDgySH7aY', title: 'タンゴのステップ バックコルテ 群馬県の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'HWV-uO0Hwf8', title: 'タンゴのステップ オープンリバースターン・レディーアウトサイド 群馬県の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'KjQkxnsOILs', title: 'タンゴのステップ ロックバック on レフトフット 群馬県の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['コメント']}},
           ],
    comment:{
      title:'トークＡにおけるタンゴ（初級）のアルガメーション',
      items: ['Walks(SS)： LF Walk(S) & RF Walk(S)',
              'Progressive Link(QQ)',
              'Closed Promenade(SQQS)',
              'Back Corte(SQQS)',
              'Walks(SS)',
              'Open Reverse Turn, Lady Outside(QQSQQS)',
              'Progressive Link(QQ)',
              'Natural Promenade Turn(SQQS)',
              'Rock Turn(SQQSQQS)',
              'Five Step(QQQQS)',
              'Natural Twist Turn(SQQSQQ)',
              'Closed Promenade(SQQS)',
              'To Slow(&S)',
              'Fallaway Promenade(SQQSQQ)',
              'Fallaway Four Step(QQQQ)',
              'Same Foot Lunge(SQQ)',
              'Outside Swivel(SQQ)',
              'Contra Check(SS)',
              'Slip(Sliding) Pivot(QQSQQ)',
              'To Slow(&S)',
              'Natural Twist Turn(SQQSQQ)',
           ],
       },
  }; // end of album_2
  album_3: Album = {
    title: 'ルンバ',
    items: [{id: '5IlfzLYadNk', title: '社交ダンス ルンバ 2019日本インター規定フィガー',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'I0d_w1Ya5BM', title: 'ルンバのステップ オープンヒップツイスト 群馬県の社交ダンス教室',
             comment: {title: 'Open Hip Twist(2341 2341 O→F)', 
             items: ['2:男性は、左足を前に出す。女性は右足を下げ左足に揃える。',
                     '3:男性は、右足に体重を乗せる。女性は左足に体重を乗せる。',
                     '41:男性は、左足を戻して右足に揃える。女性は右足を前に進めなる。',
                     '2:男性は、右足を後ろに下げる。女性は、左足を前に進めながら、2/8右回転をする。',
                     '3:男性は、左足に体重を乗せる。女性は、右足を前に進めながら、3/8左回転をする。',
                     '41:男性は、右足を左足の横に出す。女性は、左足を後ろに下げ2/8左回転する。']}},
            {id: '4KoMotpYlaY', title: 'ルンバのステップ ホッケースティック 群馬県の社交ダンス教室',
             comment: {title: 'Hockey Stick（2341 2341 F→O）',
             items: ['2:男性は、左手を上げながら左足を前に出す（チェック）。女性は右足を左足に揃える。',
                     '3:男性は、左手を上げながら右足に体重を移す。女性は左足を前に進める。',
                     '41:男性は、左手を上げながら左足を戻して右足に揃える。女性は右足を前に進める。',
                     '2:男性は、左手を上げながら右足を後ろに下げる。女性は、左足を前に進めながら、1/8左回転をする。',
                     '3:男性は、左手を下げながら左足を前に出す。女性は、右足を前に進めながら、3/8左回転をする。',
                     '41:男性は、左に回転しながら、右足を左足に揃え女性と正対する。女性は、1/8左回転して左足を横に出し男性と正対する。']}},
            {id: 'WQOt7DoLu2A', title: 'ルンバのステップ アレマーナ 群馬の社交ダンス教室',
             comment: {title: 'Alemana（2341 2341 F→O）',
             items: ['2:男性は、左足を前に出す。女性は右足を下げ左足に揃える。',
                     '3:男性は、右足に体重を乗せる。女性は左足に体重を乗せる。',
                     '41:男性は、左足を戻して右足に揃える。女性は右足を前に進めなる。',
                     '2:男性は、右足を後ろに下げる。女性は、左足を前に進めながら、2/8右回転をする。',
                     '3:男性は、左足に体重を乗せる。女性は、右足を前に進めながら、3/8左回転をする。',
                     '41:男性は、右足を左足の横に出す。女性は、左足を後ろに下げ2/8左回転する。']}},
            {id: 'mLdBlg7T1Zk', title: 'ルンバのステップ スリースリーズ 群馬の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'mLdBlg7T1Zk', title: 'ルンバのステップ スリースリーズ 群馬の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'tR3SDhlLA-4', title: 'ルンバのステップ ニューヨーク to ライトサイドポジション 群馬県の社交ダンス教室',
             comment: {title: 'Natural Turn', items: ['コメント']}},
           ],
    comment:{
      title:'トークＡにおけるルンバのアルガメーション',
      items: ['Open Hip Twist(2341 2341 O→F)',
           'Hockey Stick（2341 2341 F→O）',
           'Open Hip Twist(2341 2341 O→F)',
           'Alemana（2341 2341 F→O）',
           'Opening Out（2341 2341 O→F）',
           'Hockey Stick（2341 2341 F→O）',
           'New York to Left Side Position（2341 C→C）',
           'New York to Right Side Position（2341 C→C）',
           'New York to Left Side Position（2341 C→C）',
           'New York to Right Side Position（2341 C→C）',
           'Spot Turn to Left（2341 C→O）',
           'マンボの足1?（2341 2341 O→T）:右手で女性を握り左足を出す。右手で女性を左回転させる',
           'マンボの足2?（2341 2341 T→T）:左手を腰に置く。右手で女性を右回転させる。',
           'マンボの足3?（2341 2341 T→T）:左手を腰に置く。右手で女性を左回転させ、両手を握る。',
           'マンボの足4?（2341 2341 T→T）:両手を握りながら左足を前に出す。右足を下げる。',
           'マンボの足5?（2341 2341 T→O）:両手を握りながら左足を横に出す。右手で女性を左回転させて正対する。',
           'マンボの足6?（2341 2341 O→C）:左を握りながら左足を前に出す。右足を下げ次に左足を前に出す。',
           'Natural Top（2341 2341 2341 C→C）',
           'Rope Spinning（2341 2341 C→Ｔ（片手））',
           'Sliding Doors（2341 2341 2341 2341 2341 F→T（右手））',
           'マンボの足1?の後半（2341 C→T（片手））',
           'Circular Hip Twist（2341 2341 2341 2341 C→F）',
           'チェックして右手を上げる（2341 2341 2341 F→C）',
           'Three Alamanas（2341 2341 2341 2341 F→C）',
           'Three Threes（2341 2341 2341 2341 C→C）',
           'Opening Out to the Right and Left（2341 2341 C→C）',
           ],
    },
  }; // end of album_3
  album_4: Album = {
    title: 'ダンサー裕美',
    items: [{id: 'BMDCCtJ8CoU', title: 'バランスよく動くには【側屈】大事！！ ',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'cMeM-q95CxY', title: 'コアの大切さ',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'H1ovL2PpeSc', title: '中心を感じるラテン基本の動き',
             comment: {title: 'Natural Turn', items: ['コメント']}},
            {id: 'eokxj7bKN5A', title: '体幹からくるアーム使い',
             comment: {title: 'Natural Turn', items: ['コメント']}},
           ],
    comment:{
      title:'コメント',
      items: ['側屈を行うには肩甲骨の動きが重要らしい。',
           '肩甲骨の動きで背骨をS型に動かして、頭の位置を動かさないように調整するらしい。',
           'つまり、頭の位置を動かさないようにするには肩甲骨を使う必要がある訳だ。',
           'しかし、老化した体は、肩甲骨がサビ付いている。',
           'ダンサー裕美様の教えに従って、肩甲骨を動かして側屈運動を行おう。',
           ],
       },
  }; // end of album_4
  
  albums: Array<Album>;
  */
}
